import { TableColumnName } from '@common/types';
import { LabelField } from '@common/types/components/select';

export const getLabelForSelect = <T,>(labelField: LabelField<T> = TableColumnName.Name, record: T) => {
  return typeof labelField === 'function' ? labelField(record) : record?.[labelField];
};
